"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRootPublicPageState = void 0;
var RootPageState_init_1 = require("@/pages/common/states/RootPageState.init");
var LoginState_init_1 = require("@/pages/common/states/LoginState.init");
var state_init_1 = require("@/pages/common/components/contact/state.init");
var EnquireState_init_1 = require("@/pages/common/states/EnquireState.init");
var SignupState_init_1 = require("@/pages/common/states/SignupState.init");
var ExistingLoginState_init_1 = require("@/pages/search/states/ExistingLoginState.init");
var CallPopupState_1 = require("@/pages/callpopup/states/CallPopupState");
var defaultRootPublicPageState = __assign(__assign({}, RootPageState_init_1.defaultRootPageState), { login: LoginState_init_1.defaultLoginState, contact: state_init_1.defaultContactState, enquire: EnquireState_init_1.defaultEnquireState, signup: SignupState_init_1.defaultSignupState, existingLogin: ExistingLoginState_init_1.defaultExistingLoginState, callPopup: CallPopupState_1.defaultCallPopupState });
exports.defaultRootPublicPageState = defaultRootPublicPageState;
